/**
 * Bağlantı kurulamadı raporu — sekme oturumu başına, akış başına TEK hata kaydı.
 * ==============================================================================
 * errorLogger ağ hatalarını (ERR_NETWORK) bilerek göndermez: yayın anında sayfanın bütün paralel çağrıları aynı
 * saniyede düşer, kayıt şişer. Ama kullanıcı HİÇ bağlanamıyorsa (tarayıcı eklentisi / güvenlik yazılımı / bozuk site
 * verisi) iz kalmıyordu — "giremiyorum" diyen kullanıcının kaydı yoktu (2026-10-19, taşeron portalı).
 *
 * Kural: akışın bütün yeniden denemeleri bittiğinde bir kez çağrılır (giriş, taşeron portalı); aynı sekmede aynı akış
 * için ikinci kez göndermez. Kayıt www üzerinden gider (`/hata-kaydi` → API `/api/error-logs`, next.config rewrite):
 * API alan adına ulaşılamayan kullanıcıda da varır. Yoldaki bağlantı tokenini sunucu maskeler (piiMasking.maskUrl).
 * Hafif tutulur (axios/supabase yok) — hesapsız portal paketine ek yük getirmez.
 */

export type BaglantiAkisi = 'giris' | 'taseron-portal';

export const BAGLANTI_KAYIT_YOLU = '/hata-kaydi';

const gonderilen = new Set<string>();

/** @returns kayıt gönderildiyse true (aynı oturumda tekrar ya da yerel ortamda false) */
export function baglantiKurulamadi(akis: BaglantiAkisi, detay: Record<string, string | number | null> = {}): boolean {
  try {
    if (typeof window === 'undefined') return false;
    // errorLogger paritesi: yerel ortam canlı hata kaydına yazmaz
    if (/^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/.test(window.location.hostname)) return false;
    const anahtar = `rm_baglanti_kaydi_${akis}`;
    if (gonderilen.has(anahtar)) return false;
    gonderilen.add(anahtar);
    try {
      if (window.sessionStorage.getItem(anahtar)) return false;
      window.sessionStorage.setItem(anahtar, '1');
    } catch { /* depolama kapalı → sekme belleğindeki işaret yeter */ }

    const govde = {
      errorType: `Connection:${akis}`,
      errorMessage: 'Bağlantı kurulamadı — yeniden denemelerden sonra sunucuya ulaşılamadı',
      url: `${window.location.origin}${window.location.pathname}`,
      pathname: window.location.pathname,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 1000) : 'Unknown',
      severity: 'WARNING',
      metadata: {
        ...detay,
        cevrimici: typeof navigator !== 'undefined' ? navigator.onLine : null,
        release: (process.env.NEXT_PUBLIC_COMMIT_SHA || 'web').slice(0, 12),
      },
    };
    fetch(BAGLANTI_KAYIT_YOLU, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(govde),
      keepalive: true,
    }).catch(() => { /* rapor ASLA akışı bozmaz */ });
    return true;
  } catch {
    return false;
  }
}
